// PERMISSIONS
export const READ = "R"; //CONSULTA
export const WRITE = "W"; //Captura
export const EXECUTE = "E"; //APROBAR

// MODULES
export const MOD_LOG = "MOD_LOG";
export const MOD_USER = "MOD_USER";
export const MOD_BILL = "MOD_BILL";
export const MOD_PARAM = "MOD_PARAM";
export const MOD_PROVID = "MOD_PROVID";
export const MOD_CUSTOM = "MOD_CUSTOM";
export const MOD_RELATIONS = "MOD_RELATIONS";
export const MOD_TERM_EXTENSION = "MOD_TERM_EXTENSION";
export const MOD_DISCONT_PROV = "MOD_DISCONT_PROV";
